

// import React, { useEffect, useState } from "react";
// import api from "../";
// import "../../style/ModuloManualConvivencia.css";

// export default function ManualAdmin() {
//   const [normas, setNormas] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [modal, setModal] = useState(false);
//   const [edit, setEdit] = useState(null);

//   const [form, setForm] = useState({
//     codigo: "",
//     descripcion: "",
//     gravedad: "media",
//     activo: 1,
//   });

//   /* ============================
//       📥 CARGAR NORMAS (RECTOR)
//   ============================ */
//   const fetchNormas = async () => {
//     setLoading(true);
//     try {
//       const { data } = await api.get("/manual-convivencia/admin");
//       setNormas(data || []);
//     } catch (error) {
//       console.error("Error al cargar normas:", error);
//       alert("Error cargando normas");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchNormas();
//   }, []);

//   /* ============================
//       💾 GUARDAR
//   ============================ */
//   const guardar = async () => {
//     if (!form.codigo || !form.descripcion) {
//       return alert("Código y descripción obligatorios");
//     }

//     try {
//       if (edit) {
//         await api.put(`/manual-convivencia/${edit.id}`, form);
//       } else {
//         await api.post("/manual-convivencia", form);
//       }
//       setModal(false);
//       setForm({ codigo: "", descripcion: "", gravedad: "media", activo: 1 }); // Limpiar form
//       fetchNormas();
//     } catch (error) {
//       console.error("Error al guardar:", error);
//       alert("Error guardando norma");
//     }
//   };

//   const desactivar = async (id) => {
//     if (!window.confirm("¿Desactivar norma?")) return;
//     try {
//       await api.delete(`/manual-convivencia/${id}`);
//       fetchNormas();
//     } catch (error) {
//       alert("Error al desactivar la norma");
//     }
//   };

//   /* ============================
//       📄 DESCARGAR PDF (IP AWS)
//   ============================ */
//   const descargarPDF = () => {
//     // Corregido: Apuntando a la IP pública de tu servidor AWS
//     window.open("http://3.236.217.225:5001/api/manual-convivencia/pdf");
//   };

//   return (
//     <div className="manual-wrapper">
//       <h2>📘 Manual de Convivencia – Rector</h2>

//       <div className="manual-actions">
//         <button className="btn-new" onClick={() => { setEdit(null); setForm({ codigo: "", descripcion: "", gravedad: "media", activo: 1 }); setModal(true); }}>➕ Nueva</button>
//         <button className="btn-pdf" onClick={descargarPDF}>📄 Descargar PDF</button>
//       </div>

//       {loading ? <p className="loading">Cargando normas...</p> : (
//         <div className="table-responsive">
//           <table className="tabla-manual">
//             <thead>
//               <tr>
//                 <th>Código</th>
//                 <th>Descripción</th>
//                 <th>Gravedad</th>
//                 <th>Estado</th>
//                 <th>Acciones</th>
//               </tr>
//             </thead>
//             <tbody>
//               {normas.length > 0 ? (
//                 normas.map(n => (
//                   <tr key={n.id}>
//                     <td><strong>{n.codigo}</strong></td>
//                     <td>{n.descripcion}</td>
//                     <td><span className={`badge ${n.gravedad}`}>{n.gravedad.toUpperCase()}</span></td>
//                     <td>{n.activo ? "✅" : "❌"}</td>
//                     <td>
//                       <button className="btn-edit" onClick={() => { setEdit(n); setForm(n); setModal(true); }}>✏️</button>
//                       <button className="btn-delete" onClick={() => desactivar(n.id)}>🚫</button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="5" style={{ textAlign: 'center' }}>No hay normas registradas</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {modal && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <h3>{edit ? "Editar Norma" : "Nueva Norma"}</h3>
//             <input 
//               placeholder="Código (Ej: Art. 1)" 
//               value={form.codigo}
//               onChange={e => setForm({ ...form, codigo: e.target.value })} 
//             />

//             <textarea 
//               placeholder="Descripción de la norma..."
//               value={form.descripcion}
//               onChange={e => setForm({ ...form, descripcion: e.target.value })} 
//             />

//             <label>Gravedad:</label>
//             <select 
//               value={form.gravedad}
//               onChange={e => setForm({ ...form, gravedad: e.target.value })}>
//               <option value="leve">Leve</option>
//               <option value="media">Media</option>
//               <option value="grave">Grave</option>
//             </select>

//             <div className="modal-buttons">
//               <button className="btn-save" onClick={guardar}>💾 Guardar</button>
//               <button className="btn-close" onClick={() => setModal(false)}>❌ Cerrar</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

//
import React, { useEffect, useState, useCallback } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import { API as BASE_API } from "../config";
import "../../style/ModuloManualConvivencia.css";

const API = `${BASE_API}/manual-convivencia`;

export default function ManualAdmin() {
  const { token } = useAuth();

  const [normas, setNormas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [edit, setEdit] = useState(null);

  const [form, setForm] = useState({
    codigo: "",
    descripcion: "",
    gravedad: "media",
    activo: 1,
  });

  /* =========================================
      LIMPIAR FORM
  ========================================= */
  const limpiarForm = () => {
    setEdit(null);
    setForm({
      codigo: "",
      descripcion: "",
      gravedad: "media",
      activo: 1,
    });
  };

  /* =========================================
      CARGAR NORMAS
  ========================================= */
  const fetchNormas = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/admin`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setNormas(res.data || []);
    } catch (error) {
      console.error("❌ Error al cargar normas:", error);
      alert("Error cargando normas");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchNormas();
  }, [fetchNormas]);

  /* =========================================
      GUARDAR NORMA
  ========================================= */
  const guardar = async () => {
    if (!form.codigo.trim() || !form.descripcion.trim()) {
      return alert("Código y descripción obligatorios");
    }

    try {
      if (edit) {
        await axios.put(`${API}/${edit.id}`, form, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else {
        await axios.post(`${API}`, form, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }

      setModal(false);
      limpiarForm();
      fetchNormas();

    } catch (error) {
      console.error("❌ Error guardando:", error);
      alert(error.response?.data?.message || "Error guardando norma");
    }
  };

  /* =========================================
      DESACTIVAR
  ========================================= */
  const desactivar = async (id) => {
    if (!window.confirm("¿Desactivar norma?")) return;

    try {
      await axios.delete(`${API}/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      fetchNormas();
    } catch (error) {
      console.error(error);
      alert("Error al desactivar norma");
    }
  };

  /* =========================================
      DESCARGAR PDF
  ========================================= */
  const descargarPDF = () => {
    window.open(`${API}/pdf?token=${token}`, "_blank");
  };

  /* =========================================
      ABRIR NUEVO
  ========================================= */
  const nuevaNorma = () => {
    limpiarForm();
    setModal(true);
  };

  /* =========================================
      EDITAR
  ========================================= */
  const editarNorma = (norma) => {
    setEdit(norma);
    setForm({
      codigo: norma.codigo || "",
      descripcion: norma.descripcion || "",
      gravedad: norma.gravedad || "media",
      activo: norma.activo,
    });
    setModal(true);
  };

  return (
    <div className="manual-wrapper">

      <h2>📘 Manual de Convivencia – Rector</h2>

      <div className="manual-actions">
        <button className="btn-new" onClick={nuevaNorma}>➕ Nueva Norma</button>
        <button className="btn-pdf" onClick={descargarPDF}>📄 Descargar PDF</button>
      </div>

      {loading ? (
        <p className="loading">Cargando normas...</p>
      ) : (
        <div className="table-responsive">
          <table className="tabla-manual">
            <thead>
              <tr>
                <th>Código</th>
                <th>Descripción</th>
                <th>Gravedad</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {normas.length > 0 ? (
                normas.map((n) => (
                  <tr key={n.id}>
                    <td><strong>{n.codigo}</strong></td>
                    <td>{n.descripcion}</td>
                    <td>
                      <span className={`badge ${n.gravedad}`}>
                        {n.gravedad?.toUpperCase()}
                      </span>
                    </td>
                    <td>{n.activo ? "✅ Activa" : "🚫 Inactiva"}</td>
                    <td>
                      <button className="btn-edit" onClick={() => editarNorma(n)}>✏️</button>
                      <button className="btn-delete" onClick={() => desactivar(n.id)}>🚫</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    No hay normas registradas
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {modal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>{edit ? "✏️ Editar Norma" : "➕ Nueva Norma"}</h3>

            <input
              type="text"
              placeholder="Código (Ej: Art. 1)"
              value={form.codigo}
              onChange={(e) => setForm({ ...form, codigo: e.target.value })}
            />

            <textarea
              placeholder="Descripción de la norma..."
              value={form.descripcion}
              onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
            />

            <label>Gravedad:</label>
            <select
              value={form.gravedad}
              onChange={(e) => setForm({ ...form, gravedad: e.target.value })}
            >
              <option value="Fase 1">Fase 1</option>
              <option value="Fase 2">Fase 2</option>
              <option value="Fase 3">Fase 3</option>
            </select>

            <div className="modal-buttons">
              <button className="btn-save" onClick={guardar}>💾 Guardar</button>
              <button
                className="btn-close"
                onClick={() => {
                  setModal(false);
                  limpiarForm();
                }}
              >
                ❌ Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

